import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollSpy from "react-ui-scrollspy";
import GotoTop from "../common/GotoTop";
import ContactCTA from "../contact/contactCTA";
import CloudMigrationAbout from "./CloudMigrationAbout";
import CloudMigrationBanner from "./CloudMigrationBanner";
import CloudMigrationFaq from "./CloudMigrationFaq";
import CloudMigrationServices from "./CloudMigrationServices";

const CloudMigrationHome = () => {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Flint Infotech - Cloud Migration Solutions & IT Consulting Services
          </title>
          <meta
            name="description"
            content="Flint Infotech offers seamless Cloud Migration Solutions, ensuring effortless transformation, scalability, flexibility, and security. Trust us for expert strategic planning, cost optimization, and seamless execution of your cloud migration."
          />
          <link rel="canonical" href="https://flintinfotech.com/" />

          <meta
            property="og:title"
            content="Flint Infotech - Cloud Migration Solutions & IT Consulting Services"
          />
          <meta
            property="og:description"
            content="Flint Infotech offers seamless Cloud Migration Solutions, ensuring effortless transformation, scalability, flexibility, and security. Trust us for expert strategic planning, cost optimization, and seamless execution of your cloud migration."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://flintinfotech.com/" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Flint Infotech - Cloud Migration Solutions & IT Consulting Services"
          />
          <meta
            name="twitter:description"
            content="Flint Infotech offers seamless Cloud Migration Solutions, ensuring effortless transformation, scalability, flexibility, and security. Trust us for expert strategic planning, cost optimization, and seamless execution of your cloud migration."
          />

          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
      </HelmetProvider>

      <CloudMigrationBanner />
      <ScrollSpy>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudMigrationAbout />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudMigrationServices />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudMigrationFaq />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <ContactCTA />
        </AnimationOnScroll>
      </ScrollSpy>
      <GotoTop />
    </div>
  );
};

export default CloudMigrationHome;
